export const TITLE_COLUMN_MIN_PX = 140;
export const TITLE_COLUMN_MAX_PX = 640;
export const TITLE_COLUMN_DEFAULT_PX = 210;
export const TITLE_COLUMN_STORAGE_KEY = 'dashboard_title_column_width';

export function clampTitleColumnWidth(value: number): number {
  if (!Number.isFinite(value)) return TITLE_COLUMN_DEFAULT_PX;
  return Math.min(TITLE_COLUMN_MAX_PX, Math.max(TITLE_COLUMN_MIN_PX, Math.round(value)));
}

export function readTitleColumnWidth(): number {
  if (typeof window === 'undefined') return TITLE_COLUMN_DEFAULT_PX;
  const raw = window.localStorage.getItem(TITLE_COLUMN_STORAGE_KEY);
  if (!raw) return TITLE_COLUMN_DEFAULT_PX;
  return clampTitleColumnWidth(Number(raw));
}
